import { Accordion, AccordionDetails, AccordionSummary, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import unnamed from "../../Assets/Img/unnamed.png"
import Yuklangan from '../../Components/Yuklanganlar/Yuklangan';
// import "./Student.scss"

const BoshqaApp = () => {
  const app = [
    {
      id: 1,
      materialName: "MPCHC.exe",
      author: "",
      file: "app",
      photo: "",
      file_name: "/app/MPCHCa.exe",
      roll: ['student'],
      categories: ['public']
    },
    {
      id: 2,
      materialName: "pdf-cracker-setup",
      author: "",
      file: "app",
      photo: "",
      file_name: "/app/pdf-cracker-setup.exe",
      roll: ['student'],
      categories: ['public']
    },
    {
      id: 3,
      materialName: "Photoshop",
      author: "",
      file: "app",
      photo: "",
      file_name: "/app/Photoshop.exe",
      roll: ['student'],
      categories: ['public']
    },
    {
      id: 4,
      materialName: "PotPlayer",
      author: "",
      file: "app",
      photo: "",
      file_name: "/app/PotPlayer.exe",
      roll: ['student'],
      categories: ['public']
    },
    {
      id: 5,
      materialName: "Rufus 2.6",
      author: "",
      file: "app",
      photo: "",
      file_name: "/app/Rufus2.6.exe",
      roll: ['student'],
      categories: ['public']
    },
    {
      id: 6,
      materialName: "Total Commander Power Pack8.0.1x86",
      author: "",
      file: "app",
      photo: "",
      file_name: "/app/TotalCommanderPowerPack8.0.1x86.exe",
      roll: ['student'],
      categories: ['public']
    },
    {
      id: 7,
      materialName: "UltraISO",
      author: "",
      file: "app",
      photo: "",
      file_name: "/app/UltraISO.exe",
      roll: ['student'],
      categories: ['public']
    },

  ]
  const [dastur, setDastur] = useState(app)
  const [soni,setSoni]=useState(JSON.parse(window.localStorage.getItem("BoshqaApp"))|| false)
  const soniHendil=()=>{
    setSoni(soni+1)
    console.log(soni);
    JSON.stringify(localStorage.setItem("BoshqaApp", soni))
  }
  console.log(soni);
  return (
    <div >
      {
        dastur.map((item) => {
          return <div className='kitob'>
            <Accordion className='Accordion'>
              <AccordionSummary
                // expandIcon={<ExpandMoreIcon />}/ 
                aria-controls="panel1a-content"
                id="panel1a-header"
                style={{ color: "black" }}
              >
                <Typography className='app' id="app" >{item.id} -- {item.materialName}
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography>
                  {/* {item.author} */}
                </Typography>
              </AccordionDetails>
            </Accordion>
            <Link onClick={soniHendil} to={item.file_name} className='havola' target="_blank" download>Ko'chirish</Link>
          </div>
        })
      }
    </div>
  );
 
}
export default BoshqaApp;
